import React from 'react'
import {
  Collapse,
  TableCell,
  TableRow,
  TableBody,
  Table,
  TableHead,
  Box,
  Typography,
  Chip,
  Container,
} from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() => ({
  table: {
    backgroundColor: '#C1C1C1',
  },
  fab: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
}))

function getUserRedemptionCount(id, redeemed) {
  // Return 0 if user never redeems promo code
  if (redeemed) {
    let staff = redeemed.find((e) => e.user === id)
    return staff ? staff.count : 0
  }
  return 0
}

export const StaffBenefitUsers = (props) => {
  const { row, openShowUser } = props
  const classes = useStyles()

  return (
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
        <Collapse in={openShowUser} timeout='auto' unmountOnExit>
          <Container maxWidth='md'>
            <Box id='thisRow' margin={4}>
              {row.departments?.length > 0 && (
                <Box margin={4}>
                  <Typography style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    Limit for departments:
                  </Typography>
                  <Box margin={1} border={1}>
                    <Table size='small' aria-label='purchases'>
                      <TableHead className={classes.table}>
                        <TableRow>
                          <TableCell align='right'>Department</TableCell>
                          <TableCell align='right'>Redemption for user</TableCell>
                          <TableCell align='right'>Redemption per department</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.departments?.map((each, idx) => (
                          <TableRow key={idx}>
                            <TableCell align='right'>{each.department}</TableCell>
                            <TableCell align='right'>{each.redemptionPerUser ?? '-'}</TableCell>
                            <TableCell align='right'>
                              {each.redemptionPerDepartment ?? '-'}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Box>
              )}
              {row.users?.length > 0 && (
                <>
                  <Typography style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    Users eligible for this benefit:
                  </Typography>
                  <Box margin={1} border={1}>
                    <Table size='small' aria-label='purchases'>
                      <TableHead className={classes.table}>
                        <TableRow>
                          <TableCell align='right'>Employee ID</TableCell>
                          <TableCell align='right'>Name</TableCell>
                          <TableCell align='right'>Department</TableCell>
                          <TableCell align='right'>Redeemed</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.users.map((user, idx) => (
                          <TableRow key={idx}>
                            <TableCell align='right'>{user?.user.employeeId}</TableCell>
                            <TableCell align='right'>{user.name}</TableCell>
                            <TableCell align='right'>{user?.user.department}</TableCell>
                            <TableCell align='right'>
                              {getUserRedemptionCount(user?.user.id, row.redeemed)}/
                              {row.redemptionPerUser}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </>
              )}
            </Box>
          </Container>
        </Collapse>
      </TableCell>
    </TableRow>
  )
}
